import { useEffect, useState } from "react";
import CommonColumnjson from "../../common/columncommon.json";
import Commongrid from "../../common/Commongrid";
import Commonmodal from "../../common/Commonmodal";
import { Box, Button, TextField } from "@mui/material";
import toast from "react-hot-toast";
import dummyprofile from "../../assets/dummyprofile.png";
import VerifiedIcon from "@mui/icons-material/Verified";
import formatDate from "../../common/Formatdate";
import getactions from "../../common/getactions";
import moment from "moment";

const calculateAge = (dob) => {
  if (!dob) return "";

  const age = moment().diff(moment(dob), "years");
  return age >= 0 ? age : "";
};

export default function CustomerProfile({ setOpenTab, seletecRow }) {
  const [activeTab, setActiveTab] = useState("documents");
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const customerDocumentStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.customerDocumentType;
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [customerData, setCustomerData] = useState(null);
  const [getAllDocuments , setGetAllDocuments] = useState([])
  const [loading, setLoading] = useState(false);
  const [customerBooking, setCustomerBookings] = useState([]);
  const [columns, setColumns] = useState([
    {
      field: "id",
      headerName: "Id",
      minWidth: 100,
      align: "start",
      sortable: false,
    },
    {
      field: "bookingCode",
      headerName: "Booking Id",
      minWidth: 250,
      align: "start",
      sortable: false,
    },
    {
      field: "bookingStatusDetails",
      headerName: "Booking Status",
      minWidth: 200,
      align: "start",
      sortable: false,
    },
    {
      field: "bookFrom",
      headerName: "Start Date",
      minWidth: 200,
      align: "start",
    },
    {
      field: "bookTo",
      headerName: "End Date",
      minWidth: 200,
      align: "start",
    },
    { field: "amount", headerName: "Amount", minWidth: 150, align: "start" },
    {
      field: "createdAt",
      headerName: "Created At",
      minWidth: 170,
      align: "start",
    },
  ]);
  const [totalCount, setTotalCount] = useState(0);
  const [openImageModal, setImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const profile = JSON.parse(localStorage.getItem("profile"));
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const [form, setForm] = useState({
    name: "",
    email: "",
    dob: "",
    age: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (customerData) {
      setForm({
        name: customerData?.name || "",
        email: customerData?.email || "",
        dob: customerData?.dob || "",
        age: calculateAge(customerData?.dob) || "",
      });
    }
  }, [customerData]);

  const validate = () => {
    const newErrors = {};

    if (!form.name || form.name.length < 3) {
      newErrors.name = "Name must be at least 3 characters.";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      newErrors.email =
        "Please enter a valid email address (e.g., example@domain.com).";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "dob") {
      const age = calculateAge(value);

      setForm((prevForm) => ({
        ...prevForm,
        dob: value,
        age: age,
      }));
    } else {
      setForm((prevForm) => ({
        ...prevForm,
        [name]: value,
      }));
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }
    try {
      const response = await fetch(`${apiUrl}/api/v2/users/update-customer-details`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: seletecRow,
          name: form?.name,
          email: form?.email,
          dob: form?.dob,
          age: form?.age,
          updateBookings: true,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({
          name: "",
          email: "",
          dob: "",
          age: "",
        });
        toast.success("Details updated successfully");
        await getuserDetails();
      }
    } catch (error) {
      console.log("ERROR IN EDIT CUSTOMER DETAILS", error);
    }
  };

  const handleImageClose = () => {
    setSelectedImage(null);
    setImageModal(false);
  };

  const handleImageOpen = (url) => {
    setSelectedImage(url);
    setImageModal(true);
  };

  function createData(
    id,
    bookingCode,
    bookingStatusDetails,
    bookFrom,
    bookTo,
    amount,
    createdAt,
  ) {
    return {
      id,
      bookingCode,
      bookingStatusDetails,
      bookFrom,
      bookTo,
      amount,
      createdAt,
    };
  }

  const rows =
    (customerBooking &&
      customerBooking?.map((item) =>
        createData(
          item?.id,
          item?.bookingCode,
          item?.bookingStatusDetails,
          item?.bookFrom,
          item?.bookTo || "-",
          item?.costToCustomer,
          item?.createdAt,
        ),
      )) ||
    [];

  const tabs = [
    { id: "documents", label: "Documents" },
    { id: "bookings", label: "Bookings" },
    ...((actionsToAccess?.includes("Update Customer") && [
      { id: "edit", label: "Edit Details" },
    ]) ||
      []),
  ];

  useEffect(() => {
    setColumns(CommonColumnjson["vehicleBookings"]);
  }, [seletecRow]);

  const getuserDetails = async () => {
    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/api/users/${seletecRow}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setCustomerData(data?.entityValue);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching user:", error);
    }
  };

  const getCustomerDocumentDetails = async (userId) => {
    setLoading(true);

    try {
      const response = await fetch(
        `${apiUrl}/api/customerdocuments?limit=100&userId=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setGetAllDocuments(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching user:", error);
    }
  };

  const getuserBookingDetails = async (
    customPage = paginationModel?.page,
    customRowsPerPage = paginationModel?.pageSize,
  ) => {
    const fleetBookingStatus = JSON.parse(
      localStorage.getItem("catalogValues"),
    )?.fleetBookingStatus;
    delete fleetBookingStatus?.inverted;
    const fleetBookingvalue = fleetBookingStatus;
    const offset =
      (customPage ?? 0) * (customRowsPerPage ?? paginationModel?.pageSize);
    const filteredKeys = Object.keys(fleetBookingvalue).filter(
      (key) =>
        !fleetBookingvalue[key].includes("Inquiry") &&
        !fleetBookingvalue[key].includes("Payment Pending"),
    );
    try {
      const response = await fetch(
        `${apiUrl}/api/vehiclebookings?limit=${customRowsPerPage}&offset=${offset}&bookingStatus=[${filteredKeys}]&customerId=${seletecRow}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setTotalCount(data?.entities?.count);
        setCustomerBookings(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    if (seletecRow) {
      getuserDetails();
      getCustomerDocumentDetails(seletecRow);
      getuserBookingDetails();
    }
  }, [seletecRow]);

  return (
    <>
      {openImageModal && (
        <>
          <Commonmodal
            open={handleImageOpen}
            onClose={handleImageClose}
            url={selectedImage}
          />
        </>
      )}

      <div className="min-h-screen p-6">
        <div className="flex justify-between">
          <h3 className="text-xl font-semibold text-gray-800">View Customer</h3>
          <button
            onClick={() => {
              setOpenTab(false);
            }}
            class="bg-white text-center w-56 rounded-2xl h-14 relative text-black text-xl font-semibold group mb-2"
            type="button"
          >
            <div class="bg-green-400 rounded-xl h-12 w-1/4 flex items-center justify-center absolute left-1 top-[4px] group-hover:w-[194px] z-10 duration-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1024 1024"
                height="25px"
                width="25px"
              >
                <path
                  d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"
                  fill="#000000"
                ></path>
                <path
                  d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"
                  fill="#000000"
                ></path>
              </svg>
            </div>
            <p class="translate-x-2">Go Back</p>
          </button>
        </div>
        <div className="max-w-8xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* LEFT SIDE */}
          <div className="md:col-span-1 space-y-4">
            {/* Customer Card */}
            <div className="relative bg-white rounded-xl shadow p-5 text-center overflow-hidden">
              {customerData?.isDocVerified && (
                <div className="absolute top-4 -right-10 rotate-45 bg-green-500 text-white text-xs font-semibold px-10 py-1 shadow-md">
                  ✔ Verified
                </div>
              )}

              <img
                src={customerData?.image || dummyprofile}
                alt="Customer"
                className="w-24 h-24 rounded-full mx-auto border-4 border-blue-100"
              />

              <h2 className="mt-3 text-lg font-semibold text-gray-800">
                {customerData?.name}
              </h2>

              <p className="text-sm text-gray-500 mt-3">
                <span className="font-medium">Email:</span>{" "}
                {customerData?.email}
              </p>
              <p className="text-sm text-gray-500 mt-3">
                <span className="font-medium">DOB:</span>{" "}
                {formatDate(customerData?.dob)}
              </p>

              <p className="text-sm text-gray-500 mt-3">
                <span className="font-medium">Age:</span>
                {calculateAge(customerData?.dob)}
              </p>

              <div className="mt-4 text-sm text-gray-600 space-y-1">
                <p>
                  <span className="font-medium">Phone:</span>{" "}
                  {customerData?.mobile}
                </p>
              </div>
            </div>

            {/* Tabs */}
            <div className="bg-white rounded-xl shadow overflow-hidden">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`w-full text-left px-5 py-3 text-sm font-medium border-b last:border-b-0
                  ${
                    activeTab === tab.id
                      ? "bg-blue-100 text-blue-700 font-semibold"
                      : "text-gray-600 hover:bg-gray-50"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="md:col-span-3">
            <div className="bg-white rounded-xl shadow p-6 min-h-[400px]">
              {activeTab === "edit" && (
                <Overview
                  form={form}
                  handleChange={handleChange}
                  errors={errors}
                  handleSubmit={handleSubmit}
                />
              )}
              {activeTab === "bookings" && (
                <Bookings
                  customerBooking={customerBooking}
                  columns={columns}
                  getuserBookingDetails={getuserBookingDetails}
                  rows={rows}
                  setPaginationModel={setPaginationModel}
                  paginationModel={paginationModel}
                  loading={loading}
                  totalCount={totalCount}
                />
              )}
              {activeTab === "payments" && <Payments />}
              {activeTab === "documents" && (
                <Documents
                  customerData={customerData}
                  customerDocumentStatus={customerDocumentStatus}
                  setOpenTab={setOpenTab}
                  handleImageOpen={handleImageOpen}
                  getAllDocuments={getAllDocuments}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

/* TAB CONTENT COMPONENTS */

const Overview = ({ form, handleChange, errors, handleSubmit }) => (
  <div>
    <h3 className="text-xl font-semibold text-gray-800 mb-4">Edit Details</h3>
    <div className="flex justify-start gap-4 mt-6">
      <TextField
        required
        name="name"
        label="Full Name"
        value={form.name}
        onChange={handleChange}
        error={!!errors.name}
        helperText={errors.name}
      />

      <TextField
        required
        name="dob"
        label="Date of Birth"
        type="date"
        value={form.dob}
        onChange={handleChange}
        error={!!errors.dob}
        slotProps={{
          inputLabel: { shrink: true },
        }}
        helperText={errors.dob}
      />

      {/* <TextField
        label="Age"
        type="number"
        value={form.age}
        InputProps={{ readOnly: true }}
      /> */}

      <TextField
        required
        name="email"
        label="Email Address"
        type="email"
        value={form.email}
        onChange={handleChange}
        error={!!errors.email}
        helperText={errors.email}
      />

      <Button
        onClick={handleSubmit}
        variant="contained"
        size="large"
        sx={{
          backgroundColor: "#2e2bf5",
          px: 4,
          py: 1.5,
          borderRadius: "8px",
          fontWeight: 600,
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#222",
          },
        }}
      >
        Submit
      </Button>
    </div>
  </div>
);

const Bookings = ({
  rows,
  getuserBookingDetails,
  customerBooking,
  columns,
  setPaginationModel,
  paginationModel,
  loading,
  totalCount,
}) => (
  <div>
    <h3 className="text-xl font-semibold text-gray-800 mb-4">
      Booking History
    </h3>

    <div className="mt-4">
      <Commongrid
        rows={rows}
        columns={columns}
        totalCount={totalCount} // total rows from API
        handleViewClick={(params) => {
          const navigate = `/viewallbookings?bookingid=${params?.bookingCode}&display=true`;
          window.open(navigate, "_blank");
        }}
        api={getuserBookingDetails}
        setPaginationModel={setPaginationModel}
        paginationModel={paginationModel}
        loading={loading}
        disableColumnMenu={false}
      />
    </div>
  </div>
);

const Payments = () => (
  <div>
    <h3 className="text-xl font-semibold text-gray-800 mb-4">
      Payment Details
    </h3>
    <p className="text-gray-600">Total Paid: ₹12,500</p>
  </div>
);

const Documents = ({
  customerData,
  customerDocumentStatus,
  setOpenTab,
  handleImageOpen,
  getAllDocuments
}) => (
  <div>
    <div className="flex justify-between my-2">
      <h3 className="text-xl font-semibold text-gray-800 mb-5">
        Customer Documents
      </h3>
    </div>

    <h5 className="text-lg font-medium text-gray-800 mb-5">
      Verified Documents
    </h5>
    {customerData?.customerDocuments?.length === 0 ? (
      <div className="text-center py-10 text-gray-500">
        No documents uploaded
      </div>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {customerData?.customerDocuments?.map((doc) => {
          let attachments = [];

          // Case 1: attachments array (stringified JSON)
          if (doc.attachments) {
            try {
              attachments = JSON.parse(doc.attachments);
            } catch (err) {
              attachments = [];
            }
          }
          // Case 2: single imageUrl from API
          else if (doc.imageUrl) {
            attachments = [
              {
                url: doc.imageUrl,
                imageUrl: doc.imageUrl,
                fileName: doc.fileName || doc.docName,
              },
            ];
          }

          return (
            <div
              key={doc.id}
              className="bg-white border rounded-xl p-5 shadow-sm hover:shadow-md transition"
            >
              {/* Header */}
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h4 className="font-semibold text-gray-800">
                    {customerDocumentStatus[doc.docType]}
                  </h4>
                  <p className="text-sm text-gray-500">
                    ID No: {doc.identificationNo}
                  </p>
                </div>

                {/* Status */}
                {doc.isVerified && (
                  <span className="px-3 py-1 text-xs font-medium rounded-full bg-green-100 text-green-700">
                    Verified
                  </span>
                )}
                {doc.isRejected && (
                  <span className="px-3 py-1 text-xs font-medium rounded-full bg-red-100 text-red-700">
                    Rejected
                  </span>
                )}
              </div>

              {/* Dates */}
              <div className="text-sm text-gray-600 space-y-1 mb-4">
                <p>
                  <span className="font-medium">Valid From:</span>{" "}
                  {doc.startDate?.split(" ")[0] || "N/A"}
                </p>
                <p>
                  <span className="font-medium">Valid To:</span>{" "}
                  {doc.endDate?.split(" ")[0] || "N/A"}
                </p>
              </div>

              {/* Attachments */}
              <div>
                <p className="text-sm font-medium text-gray-700 mb-2">
                  Attachments
                </p>

                <div className="flex flex-wrap gap-3">
                  {attachments.length > 0 ? (
                    attachments.map((file, index) => (
                      <div
                        key={index}
                        onClick={() =>
                          handleImageOpen(
                            file.url || file.imageUrl || file?.filePath,
                          )
                        }
                        className="w-20 h-20 border rounded-lg overflow-hidden cursor-pointer bg-gray-50 hover:ring-2 hover:ring-blue-400 transition"
                      >
                        <img
                          src={file.url || file.imageUrl || file?.filePath}
                          alt={file.fileName}
                          className="object-cover w-full h-full"
                        />
                      </div>
                    ))
                  ) : (
                    <p className="text-xs text-gray-400">No attachments</p>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    )}


     <h5 className="text-lg font-medium text-gray-800 mb-5 mt-5">
      All Documents
    </h5>
    {getAllDocuments?.length === 0 ? (
      <div className="text-center py-10 text-gray-500">
        No documents uploaded
      </div>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 h-72 overflow-y-auto">
        {getAllDocuments?.map((doc) => {
          let attachments = [];

          // Case 1: attachments array (stringified JSON)
          if (doc.attachments) {
            try {
              attachments = JSON.parse(doc.attachments);
            } catch (err) {
              attachments = [];
            }
          }
          // Case 2: single imageUrl from API
          else if (doc.imageUrl) {
            attachments = [
              {
                url: doc.imageUrl,
                imageUrl: doc.imageUrl,
                fileName: doc.fileName || doc.docName,
              },
            ];
          }

          return (
            <div
              key={doc.id}
              className="bg-white border rounded-xl p-5 shadow-sm hover:shadow-md transition"
            >
              {/* Header */}
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h4 className="font-semibold text-gray-800">
                    {customerDocumentStatus[doc.docType]}
                  </h4>
                  <p className="text-sm text-gray-500">
                    ID No: {doc.identificationNo}
                  </p>
                </div>

                {/* Status */}
                {doc.isVerified && (
                  <span className="px-3 py-1 text-xs font-medium rounded-full bg-green-100 text-green-700">
                    Verified
                  </span>
                )}
                {!doc.isVerified && !doc.isRejected && (
                  <span className="px-3 py-1 text-xs font-medium rounded-full bg-yellow-100 text-yellow-700">
                   Not Verified
                  </span>
                )}
                {doc.isRejected && (
                  <span className="px-3 py-1 text-xs font-medium rounded-full bg-red-100 text-red-700">
                    Rejected
                  </span>
                )}
              </div>

              {/* Dates */}
              <div className="text-sm text-gray-600 space-y-1 mb-4">
                <p>
                  <span className="font-medium">Valid From:</span>{" "}
                  {doc.startDate?.split(" ")[0] || "N/A"}
                </p>
                <p>
                  <span className="font-medium">Valid To:</span>{" "}
                  {doc.endDate?.split(" ")[0] || "N/A"}
                </p>
              </div>

              {/* Attachments */}
              <div>
                <p className="text-sm font-medium text-gray-700 mb-2">
                  Attachments
                </p>

                <div className="flex flex-wrap gap-3">
                  {attachments.length > 0 ? (
                    attachments.map((file, index) => (
                      <div
                        key={index}
                        onClick={() =>
                          handleImageOpen(
                            file.url || file.imageUrl || file?.filePath,
                          )
                        }
                        className="w-20 h-20 border rounded-lg overflow-hidden cursor-pointer bg-gray-50 hover:ring-2 hover:ring-blue-400 transition"
                      >
                        <img
                          src={file.url || file.imageUrl || file?.filePath}
                          alt={file.fileName}
                          className="object-cover w-full h-full"
                        />
                      </div>
                    ))
                  ) : (
                    <p className="text-xs text-gray-400">No attachments</p>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    )}
  </div>
);
